import { AgeSurchargeType, Currency } from "@/gql/graphql";
import { AgeSurchargeIndicator } from "@/app/Common/Components/AgeSurchargeIndicator";

export function SupplierAgeRequirementIndicator({
  minimumAge,
  maximumAge,
  hasAgeSurcharge,
  minimumNoSurchargeAge,
  maximumNoSurchargeAge,
  ageSurchargeAmount,
  ageSurchargeType,
  currency,
  className,
}: {
  minimumAge?: number | null;
  maximumAge?: number | null;
  hasAgeSurcharge?: boolean | null;
  minimumNoSurchargeAge?: number | null;
  maximumNoSurchargeAge?: number | null;
  ageSurchargeAmount?: number | null;
  ageSurchargeType?: AgeSurchargeType | null;
  currency: Currency;
  className?: string;
}) {
  if (!minimumAge || !maximumAge) {
    return <p className="text-sm italic text-gray-400">Not set</p>;
  }

  if (
    hasAgeSurcharge &&
    minimumNoSurchargeAge &&
    maximumNoSurchargeAge &&
    ageSurchargeAmount &&
    ageSurchargeType
  ) {
    return (
      <AgeSurchargeIndicator
        className={className}
        minimumAge={minimumAge}
        maximumAge={maximumAge}
        minimumNoSurchargeAge={minimumNoSurchargeAge}
        maximumNoSurchargeAge={maximumNoSurchargeAge}
        ageSurchargeAmount={ageSurchargeAmount}
        ageSurchargeType={ageSurchargeType}
        currency={currency}
      />
    );
  }

  return (
    <div className={className}>
      <div className="grid grid-cols-12 overflow-hidden rounded-lg">
        <div className="col-span-2 h-8 bg-red-500" />
        <div className="col-span-8 flex h-8 items-center justify-center bg-green-500 px-3">
          <span className="text-xs font-medium text-green-900">Allowed</span>
        </div>
        <div className="col-span-2 h-8 bg-red-500" />
      </div>
      <div className="mt-2 grid grid-cols-12 text-xs text-gray-600">
        <div className="col-span-2 py-1 text-center">
          {"<"}
          {minimumAge}
        </div>
        <div className="col-span-8 py-1 text-center">
          {minimumAge} - {maximumAge}
        </div>
        <div className="col-span-2 py-1 text-center">
          {">"}
          {maximumAge}
        </div>
      </div>
    </div>
  );
}
